import React, { useEffect, useState, useContext, useRef, useMemo } from "react";
import 'react-tabs/style/react-tabs.css';
import { Header } from "../../../components/Header";
import { Menu } from "../../../components/Menu";
import { MenuPage } from "../../../components/MenuPage";
import { StyledDefaultPage } from "../../../styled-components/StyledDefaultPage.style";
import { StyledTablePmePrograma } from "../../../styled-components/StyledTablePmePrograma.style";
import { StyledTablePage } from "../../../styled-components/StyledTablePage.style";
import { MobileContext } from "../../../contexts/MobileContext";
import { StldRow } from "../../../styled-components/StldRow.style";
import { StldColumn } from "../../../styled-components/StldColumn.style";
import { StyledForm } from "../../../styled-components/StyledForm.style";
import { getEmpresas } from '../../../services/empresas';

import XLSX from 'sheetjs-style';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

import "react-datepicker/dist/react-datepicker.css";

import api from '../../../services/api';
import Flex from '@react-css/flex';
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";

export const PmeResultadosPrograma = () => {
    const isMobile = useContext(MobileContext);
    const isDesktop = !isMobile;
    const history = useHistory();
    const { idPrograma } = useParams(); 

    const [isList, setIsList] = useState(true);
    const [isLoading, setIsLoading] = useState(true);
    
    const [programaData, setProgramaData] = useState(null);
    const [listaUsuariosData, setListaUsuariosData] = useState(null);

    const [programaDataInicio, setProgramaDataInicio] = useState(null);
    const [programaDataFim, setProgramaDataFim] = useState(null);
    
    const [empresaList, setEmpresaList] = useState([]);
    var [selectedEmpresa, setselectedEmpresa] = useState(null);
    var [idEmpresa, setEmpresaId] = useState(null);

    const [mesesDisponiveis, setMesesDisponiveis] = useState([]);
    const [mesSelecionado, setMesSelecionado] = useState(11);

    const [filtroArea, setFiltroArea] = useState("");
    const [filtroNome, setFiltroNome] = useState("");
    const [minGatilhoYTD, setMinGatilhoYTD] = useState('');
    const [maxGatilhoYTD, setMaxGatilhoYTD] = useState('');
    const [minMetaYTD, setMinMetaYTD] = useState('');
    const [maxMetaYTD, setMaxMetaYTD] = useState('');
    const [minSuperMeta, setMinSuperMeta] = useState('');
    const [maxSuperMeta, setMaxSuperMeta] = useState('');

    const [listaUsuariosRanqueados, setListaUsuariosRanqueados] = useState([]);

    const tableContainerRef = useRef(null);
    const meses = [
        { nome: "JAN", numero: 0 },
        { nome: "FEV", numero: 1 },
        { nome: "MAR", numero: 2 },
        { nome: "ABR", numero: 3 },
        { nome: "MAI", numero: 4 },
        { nome: "JUN", numero: 5 },
        { nome: "JUL", numero: 6 },
        { nome: "AGO", numero: 7 },
        { nome: "SET", numero: 8 },
        { nome: "OUT", numero: 9 },
        { nome: "NOV", numero: 10 },
        { nome: "DEZ", numero: 11 }
    ];

    const handleFullscreen = () => {
        // Pega o elemento que "marcamos" com a ref
        const element = tableContainerRef.current;

        if (element) {
            // Verifica qual método de fullscreen o navegador suporta e o chama
            if (element.requestFullscreen) {
                element.requestFullscreen();
            } else if (element.mozRequestFullScreen) { // Firefox
                element.mozRequestFullScreen();
            } else if (element.webkitRequestFullscreen) { // Chrome, Safari e Opera
                element.webkitRequestFullscreen();
            } else if (element.msRequestFullscreen) { // IE/Edge
                element.msRequestFullscreen();
            }
        }
    };

    const getPrograma = async(id) => {
        const response = await api.get(`PmePrograma/${id}`);
        const programa = response.data.data;
        
        const dataInicio = new Date(programa.dataInicio);
        const dataFinal = new Date(programa.dataFim);

        const dataInicioFormatada = dataInicio.toISOString().slice(0, 19).replace("T", " ");
        const dataFinalFormatada = dataFinal.toISOString().slice(0, 19).replace("T", " ");

        const today = new Date();
        
        setProgramaDataInicio(dataInicioFormatada);
        setProgramaDataFim(dataFinalFormatada);
        setProgramaData(programa);
    };    

    const getProfissionaisPrograma = async(id, dtInicioOverride = null, dtFinalOverride = null, empresa = 0) => {
        // Se vier parâmetro na chamada, usa ele. Se não, faz o fallback pro estado atual.
        const dtInicio = dtInicioOverride || new Date(programaDataInicio);
        const dtFinal = dtFinalOverride || new Date(programaDataFim);

        // Montando a string em uma linha só para evitar sujeira de formatação (\n e espaços)
        const url = `PmeProfissionalPME/profissionais/resultados/${id}?programaDataInicio=${dtInicio.toISOString().slice(0, 19)}&programaDataFinal=${dtFinal.toISOString().slice(0, 19)}`;

        const response = await api.get(url);
        setListaUsuariosData(response.data);
    };

    const voltar = async () => {
        setIsList(true)
        history.push(`/pme-resultados/`)
    }

    const handleSetDataFim = async (mes) => {
        try {
            setIsLoading(true);
            const dataAtualizada = new Date(programaDataFim);
            dataAtualizada.setMonth(mes, 0);
            dataAtualizada.setHours(0, 0, 0, 0);

            setProgramaDataFim(dataAtualizada);
            setMesSelecionado(mes - 1);

            if (idPrograma) { 
                // Passamos as duas datas explicitamente aqui
                await getProfissionaisPrograma(idPrograma, new Date(programaDataInicio), dataAtualizada, 0);
            }
        } catch (err) {
            console.error("Erro na inicialização:", err.message);
        } finally {
            setIsLoading(false);
        }
    };

    const exportTableToExcel = (tableId, fileName) => {
        const table = document.getElementById(tableId); 
        const workbook = XLSX.utils.table_to_book(table, { raw: true }); 

        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const range = XLSX.utils.decode_range(worksheet["!ref"]); 
        const colWidths = [];

        for (let col = range.s.c; col <= range.e.c; col++) {
            const cellAddress = XLSX.utils.encode_cell({ r: 0, c: col });
            if (!worksheet[cellAddress]) continue;

            worksheet[cellAddress].s = {
                font: {
                    bold: true,
                    color: { rgb: "FFFFFF" },
                },
                fill: {
                    fgColor: { rgb: "EE4B21" },
                },
                border: {
                    top: { style: "thin", color: { rgb: "000000" } },
                    bottom: { style: "thin", color: { rgb: "000000" } },
                    left: { style: "thin", color: { rgb: "000000" } },
                    right: { style: "thin", color: { rgb: "000000" } },
                },
                alignment: {
                    horizontal: "center",
                    vertical: "center", 
                },
            };
        }

        // Itera sobre as colunas para ajustar a largura com base na segunda linha (linha de índice 1)
        for (let col = range.s.c; col <= range.e.c; col++) {
            const cellAddress = XLSX.utils.encode_cell({ r: 1, c: col }); // Segunda linha (índice 1)
            const cell = worksheet[cellAddress];
            
            if (cell && cell.v) {
                // Calcula o comprimento do texto e ajusta com um fator para espaçamento extra
                const textLength = cell.v.toString().length;
                colWidths[col] = { wch: textLength + 5 }; // +5 para espaçamento extra
            } else {
                // Se não houver valor na segunda linha, define um valor mínimo padrão
                colWidths[col] = { wch: 10 };
            }

            worksheet[cellAddress].s = {
                font: {
                    bold: true,
                    color: { rgb: "FFFFFF" }, // Texto branco
                },
                fill: {
                    fgColor: { rgb: "2C3B82" }, // Fundo azul
                },
                border: {
                    top: { style: "thin", color: { rgb: "000000" } },
                    bottom: { style: "thin", color: { rgb: "000000" } },
                    left: { style: "thin", color: { rgb: "000000" } },
                    right: { style: "thin", color: { rgb: "000000" } },
                },
                alignment: {
                    horizontal: "center",
                    vertical: "center", 
                },
            };
        }

        // Adiciona bordas ao restante das células
        for (let row = 2; row <= range.e.r; row++) {
            for (let col = 0; col <= range.e.c; col++) {
                const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
                if (!worksheet[cellAddress]) continue;
                let cellValue = worksheet[cellAddress].v;

                if (col >= 3 && col <= 5) {
                    if (typeof cellValue === 'string') {
                        cellValue = cellValue.replace(/\./g, '').replace(',', '.');
                    }

                    const numericValue = parseFloat(cellValue);

                    if (!isNaN(numericValue)) {
                        worksheet[cellAddress].v = numericValue; 
                        worksheet[cellAddress].t = 'n';          
                        worksheet[cellAddress].z = "#,##0.00";        
                    }                    
                }

                else if (col === 6) {
                    if (typeof cellValue === 'string') {
                        cellValue = cellValue.replace(/\./g, '').replace(',', '.');
                    }

                    let numericValue = parseFloat(cellValue);

                    if (!isNaN(numericValue)) {
                        numericValue = numericValue / 100;
                        worksheet[cellAddress].v = numericValue; 
                        worksheet[cellAddress].t = 'n';          
                        worksheet[cellAddress].z = "#,##0.0%";        
                    }                    
                }

                else if ((col >= 7 && col <= 12) || col === 16) {
                    if (typeof cellValue === 'string') {
                        cellValue = cellValue.replace(/\./g, '').replace(',', '.');
                    }

                    const numericValue = parseFloat(cellValue);

                    if (!isNaN(numericValue)) {
                        worksheet[cellAddress].v = numericValue; 
                        worksheet[cellAddress].t = 'n';          
                        worksheet[cellAddress].z = "#,##0.0";        
                    }                    
                }

                else if (col >= 13 && col <= 15) {
                    if (typeof cellValue === 'string') {
                        cellValue = cellValue.replace(/\./g, '').replace(',', '.');
                    }

                    let numericValue = parseFloat(cellValue);

                    if (!isNaN(numericValue)) {
                        numericValue = numericValue / 100;
                        worksheet[cellAddress].v = numericValue; 
                        worksheet[cellAddress].t = 'n';          
                        worksheet[cellAddress].z = "#,##0.0%";        
                    }                    
                }

                else if (col === 17) {
                    if (typeof cellValue === 'string') {
                        cellValue = cellValue.replace(/\./g, '').replace(',', '.');
                    }

                    const numericValue = parseFloat(cellValue);

                    if (!isNaN(numericValue)) {
                        worksheet[cellAddress].v = numericValue; 
                        worksheet[cellAddress].t = 'n';          
                        worksheet[cellAddress].z = "#,##0.000";        
                    }                    
                }

                else if (col === 20) {
                    if (typeof cellValue === 'string') {
                        cellValue = cellValue.replace(/\./g, '').replace(',', '.');
                    }

                    let numericValue = parseFloat(cellValue);

                    if (!isNaN(numericValue)) {
                        numericValue = numericValue / 100;
                        worksheet[cellAddress].v = numericValue; 
                        worksheet[cellAddress].t = 'n';          
                        worksheet[cellAddress].z = "#,##0.0%";        
                    }                    
                }

                worksheet[cellAddress].s = {
                    border: {
                        top: { style: "thin", color: { rgb: "000000" } },
                        bottom: { style: "thin", color: { rgb: "000000" } },
                        left: { style: "thin", color: { rgb: "000000" } },
                        right: { style: "thin", color: { rgb: "000000" } },
                    },
                    alignment: {
                        horizontal: "center",
                        vertical: "center", 
                    },
                };
            }
        }

        // Renomeando as colunas 13, 14 e 15
        const renomeacoes = {
            10: "Gatilho YTD",
            11: "Meta YTD",
            12: "Super Meta YTD",
            13: "% Gatilho YTD",
            14: "% Meta YTD",
            15: "% Super Meta YTD"
        };

        Object.entries(renomeacoes).forEach(([colIndex, newName]) => {
            const headerCellAddress = XLSX.utils.encode_cell({ r: 1, c: parseInt(colIndex) });
            if (worksheet[headerCellAddress]) {
                worksheet[headerCellAddress].v = newName;
            }
        });

        worksheet['!cols'] = colWidths;
        const dtInicio = programaData?.dataInicio ? new Date(programaData.dataInicio).toLocaleDateString('pt-BR') : '';
        XLSX.writeFile(workbook, `ResultadosPME_${new Date(dtInicio).getFullYear()}.xlsx`); // Salva o arquivo
    };
    
    const exportTableToPDF = (tableId) => {
        const doc = new jsPDF({ 
            orientation: 'landscape',
            unit: 'mm',
            format: [405, 297]
        });
        const table = document.getElementById(tableId);

        const dtInicio = programaData?.dataInicio ? new Date(programaData.dataInicio).toLocaleDateString('pt-BR') : '';
        const dtFinal = programaData?.dataFim ? new Date(programaData.dataFim).toLocaleDateString('pt-BR') : '';
        const title = `RESULTADOS PME ${dtInicio} - ${dtFinal}`;
        let ct = 0;
        doc.autoTable({
            html: table,
            startY: 23,
            startX: 3,
            tableWidth: 'wrap',
            styles: {
                fontSize: 10,
            },
            headStyles: {
                fillColor: [44, 59, 139],
                textColor: 255,
                valign: 'middle',
                halign: 'center',
            },
            bodyStyles: {
                cellPadding: 2,
            },
            didParseCell: (data) => {
                if(data.section === 'body') {
                    ct++;
                    const parser = new DOMParser();
                    {
                        data.cell.text = data.cell.raw.innerText.replace('\nR', ' ®')
                    }

                    if(data.cell.raw.innerHTML.includes('<i class=\"fa fa-arrow-up text-success me-2\" aria-hidden=\"true\"></i>'))
                    {
                        const parsedHTML = parser.parseFromString(data.cell.raw, 'text/html');
                        const icon = '';
                        const textoOriginal = data.cell.raw.innerText
                        data.cell.text = [`${icon} ${textoOriginal}`];
                        data.cell.styles.textColor = [0, 128, 0];
                    }
                    
                    else if(data.cell.raw.innerHTML.includes('<i class=\"fa fa-arrow-up text-warning me-2\" aria-hidden=\"true\"></i>') || data.cell.raw.innerHTML.includes('<i class=\"fa fa-arrow-down text-warning me-2\" aria-hidden=\"true\"></i>'))
                    {
                        const parsedHTML = parser.parseFromString(data.cell.raw, 'text/html');
                        const icon = '';
                        const textoOriginal = data.cell.raw.innerText
                        data.cell.text = [`${icon} ${textoOriginal}`];
                        data.cell.styles.textColor = [255, 136, 0];
                    }

                    else if(data.cell.raw.innerHTML.includes('<i class=\"fa fa-arrow-down text-danger me-2\" aria-hidden=\"true\"></i>'))
                    {
                        const parsedHTML = parser.parseFromString(data.cell.raw, 'text/html');
                        const icon = '';
                        const textoOriginal = data.cell.raw.innerText
                        data.cell.text = [`${icon} ${textoOriginal}`];
                        data.cell.styles.textColor = [255, 0, 0];
                    }
                }
            },
            didDrawCell: (data) => {
                doc.setDrawColor(224, 224, 224);
                doc.rect(
                    data.cell.x,
                    data.cell.y,
                    data.cell.width,
                    data.cell.height,
                    'S' 
                );
            },
            columnStyles: {
                0: { halign: 'center' },
                1: { halign: 'center' },
                2: { halign: 'center' },
                3: { halign: 'center' },
                4: { halign: 'center' },
                5: { halign: 'center' },
                6: { halign: 'center' },
                7: { halign: 'center' },
                8: { halign: 'center' },
                9: { halign: 'center' },
                10: { halign: 'center' },
                11: { halign: 'center' },
                12: { halign: 'center' },
                13: { halign: 'center', fontStyle: 'bold' },
                14: { halign: 'center', fontStyle: 'bold' },
                15: { halign: 'center', fontStyle: 'bold' },
                16: { halign: 'center' },
                17: { halign: 'center' },
                18: { halign: 'center' },
                19: { halign: 'center' },
            },
            didDrawPage: (data) => {
                if (data.pageNumber === 1) {
                    doc.setFontSize(16);
                    doc.setTextColor(44, 59, 130);
                    doc.text(title, doc.internal.pageSize.width / 2, 15, { align: 'center' });
                }
            },
        });
        
        doc.save(`ResultadosPME_${new Date(dtInicio).getFullYear()}.pdf`);
    };

    const normalizarArea = (nomeArea) => {
        const areaNormalizada = nomeArea.toLowerCase();

        // Mapeamento de áreas equivalentes
        if (areaNormalizada.includes("civil") || areaNormalizada.includes("descontaminacao") || areaNormalizada.includes("descontaminação")) {
            return "civil";  // Tratar "Descontaminação" como "Civil"
        }
        return areaNormalizada;
    };

    const usuariosFiltrados = useMemo(() => {
        // Evita quebra na renderização inicial se os dados ainda não chegaram
        if (!listaUsuariosRanqueados || !programaData || !programaData.gatilhos || !programaData.metas) {
            return [];
        }

        return listaUsuariosRanqueados
            .filter((usuario) =>
                usuario.nome.toLowerCase().includes(filtroNome.toLowerCase()) &&
                normalizarArea(usuario.nomeArea).includes(normalizarArea(filtroArea))
            )
            .filter((usuario) => {
                // Cálculo das porcentagens direto com os dados do C# (evitando divisão por zero)
                const percGatilhoYTD = usuario.percGatilhoYTD || 0;
                const percMetaYTD = usuario.percMetaYTD || 0;
                const percSuperMetaYTD = usuario.percSuperMetaYTD || 0;

                // 1. Filtro do Gatilho YTD
                const minGatilho = minGatilhoYTD !== '' ? parseFloat(minGatilhoYTD) : Number.NEGATIVE_INFINITY;
                const maxGatilho = maxGatilhoYTD !== '' ? parseFloat(maxGatilhoYTD) : Number.POSITIVE_INFINITY;

                if (percGatilhoYTD < minGatilho || percGatilhoYTD > maxGatilho) {
                    return false;
                }

                // 2. Filtro da Meta YTD
                const minMeta = minMetaYTD !== '' ? parseFloat(minMetaYTD) : Number.NEGATIVE_INFINITY;
                const maxMeta = maxMetaYTD !== '' ? parseFloat(maxMetaYTD) : Number.POSITIVE_INFINITY;

                if (percMetaYTD < minMeta || percMetaYTD > maxMeta) {
                    return false;
                }

                // 3. Filtro da Super Meta YTD
                const minSuper = minSuperMeta !== '' ? parseFloat(minSuperMeta) : Number.NEGATIVE_INFINITY;
                const maxSuper = maxSuperMeta !== '' ? parseFloat(maxSuperMeta) : Number.POSITIVE_INFINITY;

                return percSuperMetaYTD >= minSuper && percSuperMetaYTD <= maxSuper;
            });
    }, [
        listaUsuariosRanqueados,
        programaData,
        filtroNome,
        filtroArea,
        minGatilhoYTD,
        maxGatilhoYTD,
        minMetaYTD,
        maxMetaYTD,
        minSuperMeta,
        maxSuperMeta
    ]);

    useEffect(() => {
        const asyncFn = async () => {
            try {
                setIsLoading(true);
                setIsList(false);
                await getPrograma(idPrograma);

                const empresas = localStorage.getItem('empresasUsuario') ?
                    JSON.parse(localStorage.getItem('empresasUsuario'))
                        : [];
    
                const empresaList = await getEmpresas();
                if (!!empresaList) {
                    setEmpresaList(empresaList.filter(empresa => empresas.indexOf(empresa.idEmpresa) > -1))
                }               
                
            } catch (err) {
                console.error("Erro na inicialização:", err.message);
            } finally {
                setIsLoading(false);
            }           
        }
        asyncFn()
    }, []);

    useEffect(() => {
        const carregarProfissionais = async () => {
            if (programaData) {
                try {
                    setIsLoading(true);

                    var anoCorrente = new Date();
                    var inicioPrograma = new Date(programaDataInicio).getFullYear();
                    var mesDisponiveis = 12;
                    if (anoCorrente.getFullYear() == inicioPrograma) {
                         mesDisponiveis = anoCorrente.getMonth();
                    }                    

                    const mesesFiltrados = meses.filter(mes => mes.numero <= mesDisponiveis && mes.numero >= 0);
                    setMesesDisponiveis(mesesFiltrados); 
                    
                    await getProfissionaisPrograma(idPrograma, null, 0);
                } catch (err) {
                    console.error("Erro ao carregar profissionais:", err.message);
                } finally {
                    setIsLoading(false);
                }
            }
        };
    
        carregarProfissionais();
    }, [programaData]);

    useEffect(() => {
        if (listaUsuariosData?.data?.usuarios?.length) {
            const listaComRanking = listaUsuariosData.data.usuarios.map((usuario, index) => ({
                ...usuario,
                posicaoRanking: index + 1
            }));
            setListaUsuariosRanqueados(listaComRanking);
        }
    }, [listaUsuariosData]);

    return (
        <section>
            <main className="d-flex">
                {(() => {
                    if (isDesktop) {
                        return (
                            <Menu></Menu>
                        )
                    }
                    return null
                })()}
                <StyledDefaultPage>
                    <div className="w-100 d-flex justify-content-between align-items-center">
                        <div className="title-row">
                            <h5 className="title-row-header">PME - Resultados</h5>
                        </div>
                        <div>
                            <input type="button" className='default-button ml-3 me-1' value='Voltar' onClick={voltar} />
                            
                            { 
                                programaData?.acessoOpcaoExportacao ? (
                                <span>
                                    <button className="default-button-red me-1" onClick={() => exportTableToExcel('tabelaResultadosExcel', 'Resultados')}><i className="fa fa-download" aria-hidden="true"></i> EXPORTAR EXCEL</button>
                                    <button className="default-button-red me-1" onClick={() => exportTableToPDF('tabelaResultados')}><i className="fa fa-download" aria-hidden="true"></i> EXPORTAR PDF</button>
                                </span>
                            ) : ''}
                        </div>
                    </div>

                    <div className="card">
                        <div className="row justify-content-left mb-2">
                            <div className="col font-0-10x bold">
                                <label>
                                    <span className="me-1 text-secondary">Programa</span>
                                    <span className="me-1">
                                        Início: { programaData?.dataInicio ? new Date(programaData.dataInicio).toLocaleDateString('pt-BR') : '' } 
                                    </span>
                                    <span className="me-4">
                                        Fim: { programaData?.dataFim ? new Date(programaData.dataFim).toLocaleDateString('pt-BR') : '' }
                                    </span>
                                    { 
                                        programaData?.acessoOpcaoTotais && listaUsuariosData?.data?.resumo ? (
                                        <span>
                                            <span className="me-1 text-secondary">Total Participantes:</span>
                                            <span className="me-3">{ listaUsuariosData.data.resumo.totalParticipantes } </span>

                                            <span className="me-1 text-secondary">Total HFi:</span>
                                            <span className="me-3">{ listaUsuariosData.data.resumo.totalHFI.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) } </span>

                                            { listaUsuariosData.data.resumo.totalHFI_CD > 0 ? (
                                            <span>
                                                <span className="me-1 text-secondary">Total C.D.F.:</span>
                                                <span className="me-3">{ listaUsuariosData.data.resumo.totalHFI_CD.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }</span>
                                            </span>
                                            ) : ''} 
                                            <span className="me-1 text-secondary">M.E.Q.:</span>
                                            <span className="me-3">{ listaUsuariosData.data.resumo.totalHFI_MEQ.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }</span>

                                            <span className="me-1 text-secondary">HMFu M.E.Q.:</span>
                                            <span className="me-3">{ listaUsuariosData.data.resumo.hmFu_MEQ.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }</span>
                                            
                                            <span className="me-1 text-secondary">% Receb.:</span>
                                            <span className="me-3">{ listaUsuariosData.data.resumo.percRecebimento.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }</span>
                                        </span>
                                    ) : ''}
                                </label>
                            </div>
                        </div>
                        <div className="row justify-content-left mb-2">
                            <div className="col-sm-11 col-md-11 col-lg-11 col-xxl-11">
                                {mesesDisponiveis.map((mes) => (
                                    <input
                                        key={mes.nome}
                                        type="button"
                                        className={mesSelecionado > (mes.numero - 1) ? "default-button me-1" : "default-button-red me-1"}
                                        value={mes.nome}
                                        onClick={() => handleSetDataFim(mes.numero + 1)}
                                        style={{ minWidth: '100px', height: '45px' }}
                                    />
                                ))}
                            </div>
                            <div className="col-sm-1 col-md-1 col-lg-1 col-xxl-1 d-flex justify-content-end">
                                <button onClick={handleFullscreen} className="default-button-red me-1 p-0" style={{ minWidth: '32px', height: '32px' }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="18" height="18"><path fill={'white'} d="M168 32L24 32C10.7 32 0 42.7 0 56L0 200c0 9.7 5.8 18.5 14.8 22.2S34.1 223.8 41 217l40-40 79 79-79 79-40-40c-6.9-6.9-17.2-8.9-26.2-5.2S0 302.3 0 312L0 456c0 13.3 10.7 24 24 24l144 0c9.7 0 18.5-5.8 22.2-14.8s1.7-19.3-5.2-26.2l-40-40 79-79 79 79-40 40c-6.9 6.9-8.9 17.2-5.2 26.2S270.3 480 280 480l144 0c13.3 0 24-10.7 24-24l0-144c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2l-40 40-79-79 79-79 40 40c6.9 6.9 17.2 8.9 26.2 5.2S448 209.7 448 200l0-144c0-13.3-10.7-24-24-24L280 32c-9.7 0-18.5 5.8-22.2 14.8S256.2 66.1 263 73l40 40-79 79-79-79 40-40c6.9-6.9 8.9-17.2 5.2-26.2S177.7 32 168 32z"/></svg>
                                </button>
                            </div>
                        </div>
                        <StldRow>
                            <Flex>
                                <StyledForm style={{ width: "100%" }}>
                                {
                                    isLoading ?
                                    <StldRow>
                                        <div className="text-center">
                                            <div className="d-flex align-items-center">
                                                <strong style={{ color: "#EE4B21" }}>Carregando...</strong>
                                                <div className="spinner-border ms-auto" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                                            </div>
                                        </div>
                                    </StldRow>
                                    :
                                    <StyledTablePmePrograma>
                                        <StyledTablePage>
                                            {
                                                listaUsuariosData?.data?.usuarios?.length > 0 ?
                                                (
                                                    <div className="table-scroll font-0-9x table-bordered table-container" ref={tableContainerRef} style={{borderLeft: "none", borderRight: "none", borderBottom: "none", minHeight: '640px', backgroundColor: '#FFFFFF'}}>
                                                        <table className="table table-width table-sm table-hover" id="tabelaResultados" style={{ minWidth: '1400px' }}>
                                                            <thead>
                                                                <tr className="table-legend-info text-center" style={{backgroundColor: "#2c3b82", color: "#FFFFFF"}}>
                                                                    <td colSpan={4}>Informações Gerais</td>
                                                                    <td colSpan={3}>Horas Faturadas</td>
                                                                    { new Date(programaData?.dataInicio).getFullYear() !== 2023 && (<td colSpan={4}>Calibrações</td> )}
                                                                    { new Date(programaData?.dataInicio).getFullYear() === 2023 && (<td colSpan={3}>Calibrações</td> )}

                                                                    { new Date(programaData?.dataInicio).getFullYear() !== 2023 && (<td colSpan={6}>Acompanhamento / Elegibilidade Individual</td> )}
                                                                    { new Date(programaData?.dataInicio).getFullYear() === 2023 && (<td colSpan={4}>Acompanhamento / Elegibilidade Individual</td> )}
                                                                    
                                                                    { programaData?.acessoOpcaoColunasMerito ? (<td colSpan={5}>Méritos</td>)  : (<td colSpan={3}>Méritos</td>)}
                                                                </tr>
                                                                <tr className="table-legend-info">
                                                                    <th key="Medal" style={{ fontSize: "12px" }}>Ranking</th>
                                                                    <th key="Rookies" style={{ fontSize: "12px" }}>Rookies</th>
                                                                    <th key="nomeUsuario" style={{ width: "140px", fontSize: "12px" }}>Profissional
                                                                        <input
                                                                            type="text"
                                                                            placeholder="..."
                                                                            value={filtroNome}
                                                                            onChange={(e) => setFiltroNome(e.target.value)}
                                                                            style={{ width: "95%", marginTop: "5px", height: "30px" }}
                                                                        />
                                                                    </th>                                                                    
                                                                    <th key="nomeArea" style={{ width: "70px", fontSize: "12px" }}>Área
                                                                        <input
                                                                            type="text"
                                                                            placeholder="..."
                                                                            value={filtroArea}
                                                                            onChange={(e) => setFiltroArea(e.target.value)}
                                                                            style={{ width: "95%", marginTop: "5px", height: "30px" }}
                                                                        />
                                                                    </th>

                                                                    <th key="HFi" style={{ fontSize: "12px" }}>HFi</th>
                                                                    <th key="HMFu" style={{ fontSize: "12px" }}>HMFu</th>
                                                                    <th key="HMFg" style={{ fontSize: "12px" }}>HMFg</th>

                                                                    <th key="percProfissionalCalibTotal" style={{ fontSize: "12px" }}>% Calib. <br />Total</th>
                                                                    <th key="gatilho" style={{ fontSize: "12px" }}>Gatilho</th>
                                                                    <th key="meta" style={{ fontSize: "12px" }}>Meta</th>
                                                                    { new Date(programaData?.dataInicio).getFullYear() !== 2023 && ( <th key="superMeta" style={{ fontSize: "12px" }}>Super<br />Meta</th> )}

                                                                    <th key="metaYTDGatilho" style={{ fontSize: "12px" }}>Gatilho<br />YTD</th>
                                                                    <th key="metaYTD" style={{ fontSize: "12px" }}>Meta<br />YTD</th>
                                                                    { new Date(programaData?.dataInicio).getFullYear() !== 2023 && ( <th key="metaYTDSuper" style={{ fontSize: "12px" }}>Super<br />Meta<br />YTD</th> )}
                                                                    <th key="metaYTDPercGatilho">
                                                                        <div className="row">
                                                                            <div className="col pt-3 pe-0" style={{ fontSize: "12px" }}>Gatilho<br />YTD</div>
                                                                            <div className="col ps-0 ms-0" style={{ fontSize: "12px" }}>
                                                                                <input
                                                                                    value={minGatilhoYTD}
                                                                                    onChange={(e) => setMinGatilhoYTD(e.target.value)}
                                                                                    type="number"
                                                                                    placeholder={`Min`}
                                                                                    style={{ width: '53px', marginRight: '0px', height: "27px" }}
                                                                                />
                                                                                <div className="pe-1" style={{ fontSize: "12px" }}>Até</div>
                                                                                <input
                                                                                    value={maxGatilhoYTD}
                                                                                    onChange={(e) => setMaxGatilhoYTD(e.target.value)}
                                                                                    type="number"
                                                                                    placeholder={`Max`}
                                                                                    style={{ width: '53px', marginLeft: '0px', height: "27px" }}
                                                                                />
                                                                            </div>
                                                                        </div> 
                                                                    </th>
                                                                    <th key="metaYTDPerc">
                                                                        <div className="row">
                                                                            <div className="col pt-3 pe-0" style={{ fontSize: "12px" }}>Meta<br />YTD</div>
                                                                            <div className="col ps-0 ms-0" style={{ fontSize: "12px" }}>
                                                                            <input
                                                                                value={minMetaYTD}
                                                                                onChange={(e) => setMinMetaYTD(e.target.value)}
                                                                                type="number"
                                                                                placeholder={`Min`}
                                                                                style={{ width: '53px', marginRight: '0px', height: "27px" }}
                                                                                name="maxMeta"
                                                                            />
                                                                            <div className="pe-1" style={{ fontSize: "12px" }}>Até</div>
                                                                            <input
                                                                                value={maxMetaYTD}
                                                                                onChange={(e) => setMaxMetaYTD(e.target.value)}
                                                                                type="number"
                                                                                placeholder={`Max`}
                                                                                style={{ width: '53px', marginLeft: '0px', height: "27px" }}
                                                                                name="minMeta"
                                                                            />
                                                                            </div>
                                                                        </div>
                                                                    </th>
                                                                    { new Date(programaData?.dataInicio).getFullYear() !== 2023 && ( 
                                                                        <th key="metaYTDPercSuper">
                                                                            <div className="row">
                                                                                <div className="col pt-1 pe-0" style={{ fontSize: "12px" }}>Super<br />Meta<br />YTD</div>
                                                                                <div className="col ps-0 ms-0" style={{ fontSize: "12px" }}>
                                                                                <input
                                                                                    value={minSuperMeta}
                                                                                    onChange={(e) => setMinSuperMeta(e.target.value)}
                                                                                    type="number"
                                                                                    placeholder={`Min`}
                                                                                    style={{ width: '53px', marginRight: '0px', height: "27px" }}
                                                                                    name="maxSuperMeta"
                                                                                />
                                                                                <div className="pe-1" style={{ fontSize: "12px" }}>Até</div>
                                                                                <input
                                                                                    value={maxSuperMeta}
                                                                                    onChange={(e) => setMaxSuperMeta(e.target.value)}
                                                                                    type="number"
                                                                                    placeholder={`Max`}
                                                                                    style={{ width: '53px', marginLeft: '0px', height: "27px" }}
                                                                                    name="minSuperMeta"
                                                                                />
                                                                                </div>
                                                                            </div>
                                                                        </th> )}
                                                                    { programaData?.acessoOpcaoColunasMerito ? (<>
                                                                        <th key="metaHFIc" style={{ fontSize: "12px" }}>HFIc</th>
                                                                        <th key="metaMeritos" style={{ fontSize: "12px" }}>M.P.</th>
                                                                        <th key="metaMultiplicadores" style={{ fontSize: "12px" }}>Multiplicador</th>
                                                                        <th key="metaMultiplicadoresProporc" style={{ fontSize: "12px" }}>Multiplicador <br/> Proporcional <br/>(% Tempo)</th>
                                                                        <th key="porcRecebimento" style={{ fontSize: "12px" }}>%<br/>Receb.</th>
                                                                    </>) : (<>
                                                                        <th key="metaHFIc" style={{ fontSize: "12px" }}>HFIc</th>
                                                                        <th key="metaMeritos" style={{ fontSize: "12px" }}>M.P.</th>
                                                                        <th key="porcRecebimento" style={{ fontSize: "12px" }}>%<br/>Receb.</th>
                                                                    </>)}
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    usuariosFiltrados.map((usuario, index) => {
                                                                        const hfmu = usuario.hfMu || 0;
                                                                        const hfmg = usuario.hfMg || 0;
                                                                        const hfmic = usuario.hfIc || 0;
                                                                        const meritos = usuario.valorMerito || 0;
                                                                        const multiplicador = usuario.multiplicador || 0;
                                                                        const multiplicadorTempo = usuario.multiplicadorTempo || 0;
                                                                        const multiplicadorHFIc = usuario.multiplicadorHFIc || 0;
                                                                        const multiplicadorTempoHFIc = usuario.multiplicadorTempoHFIc || 0;

                                                                        return (
                                                                            <tr 
                                                                                key={`row-profissional-${usuario.idProfissional}`} 
                                                                                style={{
                                                                                    fontSize: '0.74rem', // ou '13px', dependendo da visão (Admin/Perito) que você estiver editando
                                                                                    backgroundColor: 
                                                                                        usuario.horaFaturada < usuario.gatilhoYTD || usuario.hfMg < programaData.gatilhos[0].horaMediaFaturadaGlobal
                                                                                        ? '#f7d6e67c' : // Vermelho se menor que gatilho YTD individual ou se a empresa não bateu o gatilho global
                                                                                        usuario.posicao <= 3 && usuario.isApto ? '#D2F4EA' : 'transparent' // Verde (Top 3) ou Transparente
                                                                                }}
                                                                            >
                                                                                <td className="text-center">
                                                                                    { usuario.posicao <= 3 ?
                                                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="16" height="14" className="mr-1">
                                                                                            <path 
                                                                                            // Adiciona a lógica de cor aqui
                                                                                            fill={
                                                                                                usuario.posicao === 1 ? '#FFD700' : // 1º Lugar (Gold)
                                                                                                usuario.posicao === 2 ? '#C0C0C0' : // 2º Lugar (Silver)
                                                                                                '#CD7F32'  // 3º Lugar (Bronze)
                                                                                            }
                                                                                            d="M4.1 38.2C1.4 34.2 0 29.4 0 24.6C0 11 11 0 24.6 0L133.9 0c11.2 0 21.7 5.9 27.4 15.5l68.5 114.1c-48.2 6.1-91.3 28.6-123.4 61.9L4.1 38.2zm503.7 0L405.6 191.5c-32.1-33.3-75.2-55.8-123.4-61.9L350.7 15.5C356.5 5.9 366.9 0 378.1 0L487.4 0C501 0 512 11 512 24.6c0 4.8-1.4 9.6-4.1 13.6zM80 336a176 176 0 1 1 352 0A176 176 0 1 1 80 336zm184.4-94.9c-3.4-7-13.3-7-16.8 0l-22.4 45.4c-1.4 2.8-4 4.7-7 5.1L168 298.9c-7.7 1.1-10.7 10.5-5.2 16l36.3 35.4c2.2 2.2 3.2 5.2 2.7 8.3l-8.6 49.9c-1.3 7.6 6.7 13.5 13.6 9.9l44.8-23.6c2.7-1.4 6-1.4 8.7 0l44.8 23.6c6.9 3.6 14.9-2.2 13.6-9.9l-8.6-49.9c-.5-3 .5-6.1 2.7-8.3l36.3-35.4c5.6-5.4 2.5-14.8-5.2-16l-50.1-7.3c-3-.4-5.7-2.4-7-5.1l-22.4-45.4z"
                                                                                            />
                                                                                        </svg>
                                                                                    :
                                                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="16" height="14" className="mr-1"><path fill={'#E7EEED'} d="M0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32z"/></svg>
                                                                                    }
                                                                                    
                                                                                    <span className="bold">{ usuario.posicao }º</span>
                                                                                </td>
                                                                                <td className="text-center">
                                                                                    {
                                                                                        usuario.isRookie 
                                                                                        ? (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="18" height="18" className="mr-1"><path fill={'#F0A80E'} path d="M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM200 144l80 0c39.8 0 72 32.2 72 72 0 28.9-17 53.8-41.6 65.3l30.2 50.3c6.8 11.4 3.1 26.1-8.2 32.9s-26.1 3.1-32.9-8.2l-41-68.3-34.4 0 0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-176c0-13.3 10.7-24 24-24zm72 96l8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0 0 48 48 0z"/></svg>) 
                                                                                        : '-'
                                                                                    }
                                                                                </td>
                                                                                <td className="text-center">{ usuario.nome }</td>
                                                                                <td className="text-center">{ usuario.nomeArea }</td>
                                                                                
                                                                                <td className="text-center" style={{ backgroundColor: usuario.horaFaturada < usuario.gatilhoCalibrado ? '#d92c5411' : 'transparent' }}>{ usuario.horaFaturada.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }</td>
                                                                                <td className="text-center" style={{ backgroundColor: usuario.hfMu < usuario.gatilhoCalibrado && usuario.hfMu !== 0 ? '#d92c5411' : 'transparent' }}>{ usuario.hfMu == 0 ? '-' : usuario.hfMu.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }</td>
                                                                                <td className="text-center" style={{ backgroundColor: usuario.hfMg < usuario.gatilhoCalibrado ? '#d92c5411' : 'transparent' }}>{ usuario.hfMg.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }</td>

                                                                                <td className="text-center">{ (usuario.calibracaoTotal * 100).toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) }%</td>
                                                                                <td className="text-center">{ usuario.gatilhoCalibrado.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) }</td>
                                                                                <td className="text-center">{ usuario.metaCalibrada.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) }</td>
                                                                                { new Date(programaData?.dataInicio).getFullYear() !== 2023 && ( <td className="text-center">{ usuario.superMetaCalibrada.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) }</td> )}

                                                                                <td className="text-center">{ usuario.gatilhoYTD.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) }</td>
                                                                                <td className="text-center">{ usuario.metaYTD.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) }</td>
                                                                                { new Date(programaData?.dataInicio).getFullYear() !== 2023 && ( <td className="text-center">{ usuario.superMetaYTD.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) }</td> )}
                                                                                
                                                                                <td className="text-center">
                                                                                    { 
                                                                                        (() => {
                                                                                            const perc = usuario.percGatilhoYTD;
                                                                                            
                                                                                            if (perc >= 100) return <i className="fa fa-arrow-up text-success me-2" aria-hidden="true"></i>;
                                                                                            if (perc >= 75) return <i className="fa fa-arrow-up text-warning me-2" aria-hidden="true"></i>;
                                                                                            if (perc >= 50) return <i className="fa fa-arrow-down text-warning me-2" aria-hidden="true"></i>;
                                                                                            return <i className="fa fa-arrow-down text-danger me-2" aria-hidden="true"></i>;
                                                                                        })()
                                                                                    }
                                                                                    { usuario.percGatilhoYTD.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) }%
                                                                                </td>
                                                                                <td className="text-center">
                                                                                    { 
                                                                                        (() => {
                                                                                            const perc = usuario.percMetaYTD;
                                                                                            
                                                                                            if (perc >= 100) return <i className="fa fa-arrow-up text-success me-2" aria-hidden="true"></i>;
                                                                                            if (perc >= 75) return <i className="fa fa-arrow-up text-warning me-2" aria-hidden="true"></i>;
                                                                                            if (perc >= 50) return <i className="fa fa-arrow-down text-warning me-2" aria-hidden="true"></i>;
                                                                                            return <i className="fa fa-arrow-down text-danger me-2" aria-hidden="true"></i>;
                                                                                        })()
                                                                                    }
                                                                                    { usuario.percMetaYTD.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) }%
                                                                                </td>
                                                                                { new Date(programaData?.dataInicio).getFullYear() !== 2023 && (
                                                                                <td className="text-center">
                                                                                    { 
                                                                                        (() => {
                                                                                            const perc = usuario.percSuperMetaYTD;
                                                                                            
                                                                                            if (perc >= 100) return <i className="fa fa-arrow-up text-success me-2" aria-hidden="true"></i>;
                                                                                            if (perc >= 75) return <i className="fa fa-arrow-up text-warning me-2" aria-hidden="true"></i>;
                                                                                            if (perc >= 50) return <i className="fa fa-arrow-down text-warning me-2" aria-hidden="true"></i>;
                                                                                            return <i className="fa fa-arrow-down text-danger me-2" aria-hidden="true"></i>;
                                                                                        })()
                                                                                    }
                                                                                    { usuario.percSuperMetaYTD.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) }%
                                                                                </td>
                                                                                )}

                                                                                { programaData?.acessoOpcaoColunasMerito ? (<>
                                                                                    <td className="text-center">{ hfmic.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }</td>
                                                                                    <td className="text-center">
                                                                                        { 
                                                                                            usuario.isApto && usuario.isAptoMP
                                                                                                ? meritos.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                                                                : "-"  
                                                                                        }
                                                                                    </td>
                                                                                    <td className="text-center">{ 
                                                                                        usuario.isApto && hfmic >= programaData.gatilhos[0].horaFaturadaIndividual
                                                                                            ?  usuario.isAptoMP
                                                                                                ? multiplicador.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) 
                                                                                                : multiplicadorHFIc.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                                                            : 'S/ Mult.'
                                                                                    }
                                                                                    </td>
                                                                                    <td className="text-center">{ 
                                                                                        usuario.isApto && hfmic >= programaData.gatilhos[0].horaFaturadaIndividual
                                                                                            ?  usuario.isAptoMP
                                                                                                ? multiplicadorTempo.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) 
                                                                                                : multiplicadorTempoHFIc.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                                                            : 'S/ Mult.'
                                                                                    }
                                                                                    </td>
                                                                                    <td className="text-left">
                                                                                        { 
                                                                                            (() => {
                                                                                                const percReceb = (usuario.horaRecebida / usuario.horaFaturada) * 100;
                                                                                        
                                                                                                if (percReceb >= 100) {
                                                                                                    return <i className="fa fa-battery-full text-success me-2" aria-hidden="true"></i>;
                                                                                                } else if (percReceb >= 75 && percReceb < 100) {
                                                                                                    return <i className="fa fa-battery-three-quarters text-warning me-2" aria-hidden="true"></i>;
                                                                                                } else if (percReceb >= 50 && percReceb < 75) {
                                                                                                    return <i className="fa fa-battery-half text-warning me-2" aria-hidden="true"></i>;
                                                                                                } else if (percReceb >= 1 && percReceb < 50) {
                                                                                                    return <i className="fa fa-battery-quarter text-danger me-2" aria-hidden="true"></i>;
                                                                                                } else {
                                                                                                    return <i className="fa fa-battery-empty text-danger me-2" aria-hidden="true"></i>;
                                                                                                }
                                                                                            })()
                                                                                        }
                                                                                        {  ((usuario.horaRecebida / usuario.horaFaturada) * 100 > 0 ? (usuario.horaRecebida / usuario.horaFaturada) * 100 : 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }%
                                                                                    </td>
                                                                                </>) : (<>
                                                                                    <td className="text-center">{ hfmic.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }</td>
                                                                                    <td className="text-center">
                                                                                        { 
                                                                                            usuario.isApto && usuario.isAptoMP
                                                                                                ? meritos.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                                                                : "-" 
                                                                                        }
                                                                                    </td>
                                                                                    <td className="text-left">
                                                                                        { 
                                                                                            (() => {
                                                                                                const percReceb = (usuario.horaRecebida / usuario.horaFaturada) * 100;
                                                                                        
                                                                                                if (percReceb >= 100) {
                                                                                                    return <i className="fa fa-battery-full text-success me-2" aria-hidden="true"></i>;
                                                                                                } else if (percReceb >= 75 && percReceb < 100) {
                                                                                                    return <i className="fa fa-battery-three-quarters text-warning me-2" aria-hidden="true"></i>;
                                                                                                } else if (percReceb >= 50 && percReceb < 75) {
                                                                                                    return <i className="fa fa-battery-half text-warning me-2" aria-hidden="true"></i>;
                                                                                                } else if (percReceb >= 1 && percReceb < 50) {
                                                                                                    return <i className="fa fa-battery-quarter text-danger me-2" aria-hidden="true"></i>;
                                                                                                } else {
                                                                                                    return <i className="fa fa-battery-empty text-danger me-2" aria-hidden="true"></i>;
                                                                                                }
                                                                                            })()
                                                                                        }
                                                                                        {  ((usuario.horaRecebida / usuario.horaFaturada) * 100 > 0 ? (usuario.horaRecebida / usuario.horaFaturada) * 100 : 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }
                                                                                    </td>
                                                                                </>)}
                                                                            </tr>
                                                                        )})
                                                                }
                                                            </tbody>
                                                        </table>
                                                        
                                                        {/* Tabela de Exportação */}
                                                        <table className="table table-width table-sm table-hover" id="tabelaResultadosExcel" style={{display: "none"}}>
                                                            <thead>
                                                                <tr className="table-legend-info text-center" style={{backgroundColor: "#2c3b82", color: "#FFFFFF"}}>
                                                                    <td colSpan={3}>Informações Gerais</td>
                                                                    <td colSpan={3}>Horas Faturadas</td>
                                                                    { new Date(programaData?.dataInicio).getFullYear() !== 2023 && (<td colSpan={4}>Calibrações</td> )}
                                                                    { new Date(programaData?.dataInicio).getFullYear() === 2023 && (<td colSpan={3}>Calibrações</td> )}

                                                                    { new Date(programaData?.dataInicio).getFullYear() !== 2023 && (<td colSpan={6}>Acompanhamento / Elegibilidade Individual</td> )}
                                                                    { new Date(programaData?.dataInicio).getFullYear() === 2023 && (<td colSpan={4}>Acompanhamento / Elegibilidade Individual</td> )}
                                                                    
                                                                    <td colSpan={5}>Méritos</td>
                                                                </tr>
                                                                <tr className="table-legend-info">
                                                                    <th key="Rookies">Rookies</th>
                                                                    <th key="nomeUsuario" style={{width: "170px"}}>Profissional
                                                                        <input
                                                                            type="text"
                                                                            placeholder="..."
                                                                            value={filtroNome}
                                                                            onChange={(e) => setFiltroNome(e.target.value)}
                                                                            style={{ width: "100%", marginTop: "5px", height: "30px" }}
                                                                        />
                                                                    </th>                                                                    
                                                                    <th key="nomeArea" style={{width: "100px"}}>Área
                                                                        <input
                                                                            type="text"
                                                                            placeholder="..."
                                                                            value={filtroArea}
                                                                            onChange={(e) => setFiltroArea(e.target.value)}
                                                                            style={{ width: "100%", marginTop: "5px", height: "30px" }}
                                                                        />
                                                                    </th>

                                                                    <th key="HFi">HFi</th>
                                                                    <th key="HMFu">HMFu</th>
                                                                    <th key="HMFg">HMFg</th>

                                                                    <th key="percProfissionalCalibTotal">% Calib. <br />Total</th>
                                                                    <th key="gatilho">Gatilho</th>
                                                                    <th key="meta">Meta</th>
                                                                    { new Date(programaData?.dataInicio).getFullYear() !== 2023 && ( <th key="superMeta">Super Meta</th> )}

                                                                    <th key="metaYTDGatilho">Gatilho<br />YTD</th>
                                                                    <th key="metaYTD">Meta<br />YTD</th>
                                                                    { new Date(programaData?.dataInicio).getFullYear() !== 2023 && ( <th key="metaYTDSuper">Super<br />Meta<br />YTD</th> )}
                                                                    <th key="metaYTDPercGatilho">
                                                                        <div className="row">
                                                                            <div className="col pt-3 pe-0">Gatilho<br />YTD</div>
                                                                            <div className="col ps-0 ms-0">                                                                                
                                                                                <input
                                                                                    value={minGatilhoYTD}
                                                                                    onChange={(e) => setMinGatilhoYTD(e.target.value)}
                                                                                    type="number"
                                                                                    placeholder={`Min`}
                                                                                    style={{ width: '53px', marginRight: '0px', height: "27px" }}
                                                                                />
                                                                                <div className="pe-1">Até</div>
                                                                                <input
                                                                                    value={maxGatilhoYTD}
                                                                                    onChange={(e) => setMaxGatilhoYTD(e.target.value)}
                                                                                    type="number"
                                                                                    placeholder={`Max`}
                                                                                    style={{ width: '53px', marginLeft: '0px', height: "27px" }}
                                                                                />
                                                                            </div>
                                                                        </div> 
                                                                    </th>
                                                                    <th key="metaYTDPerc">
                                                                        <div className="row">
                                                                            <div className="col pt-3 pe-0">Meta<br />YTD</div>
                                                                            <div className="col ps-0 ms-0">
                                                                            <input
                                                                                value={minMetaYTD}
                                                                                onChange={(e) => setMinMetaYTD(e.target.value)}
                                                                                type="number"
                                                                                placeholder={`Min`}
                                                                                style={{ width: '53px', marginRight: '0px', height: "27px" }}
                                                                                name="maxMeta"
                                                                            />
                                                                            <div className="pe-1">Até</div>
                                                                            <input
                                                                                value={maxMetaYTD}
                                                                                onChange={(e) => setMaxMetaYTD(e.target.value)}
                                                                                type="number"
                                                                                placeholder={`Max`}
                                                                                style={{ width: '53px', marginLeft: '0px', height: "27px" }}
                                                                                name="minMeta"
                                                                            />
                                                                            </div>
                                                                        </div>
                                                                    </th>
                                                                    { new Date(programaData?.dataInicio).getFullYear() !== 2023 && ( 
                                                                        <th key="metaYTDPercSuper">
                                                                            <div className="row">
                                                                                <div className="col pt-1 pe-0">Super<br />Meta<br />YTD</div>
                                                                                <div className="col ps-0 ms-0">
                                                                                <input
                                                                                    value={minMetaYTD}
                                                                                    onChange={(e) => setMinSuperMeta(e.target.value)}
                                                                                    type="number"
                                                                                    placeholder={`Min`}
                                                                                    style={{ width: '53px', marginRight: '0px', height: "27px" }}
                                                                                    name="maxSuperMeta"
                                                                                />
                                                                                <div className="pe-1">Até</div>
                                                                                <input
                                                                                    value={maxMetaYTD}
                                                                                    onChange={(e) => setMaxSuperMeta(e.target.value)}
                                                                                    type="number"
                                                                                    placeholder={`Max`}
                                                                                    style={{ width: '53px', marginLeft: '0px', height: "27px" }}
                                                                                    name="minSuperMeta"
                                                                                />
                                                                                </div>
                                                                            </div>
                                                                        </th> )}

                                                                    <th key="metaHFIc">HFIc</th>
                                                                    <th key="metaMeritos">M.P.</th>
                                                                    <th key="metaMultiplicadores">Multiplicador</th>
                                                                    <th key="metaMultiplicadoresProporc">Multiplicador <br/> Proporcional <br/>(% Tempo)</th>
                                                                    <th key="porcRecebimento">% Receb.</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    usuariosFiltrados.map((usuario, index) => {
                                                                        const hfmu = usuario.hfMu || 0;
                                                                        const hfmg = usuario.hfMg || 0;
                                                                        const hfmic = usuario.hfIc || 0;
                                                                        const meritos = usuario.valorMerito || 0;
                                                                        const multiplicador = usuario.multiplicador || 0;
                                                                        const multiplicadorTempo = usuario.multiplicadorTempo || 0;
                                                                        const multiplicadorHFIc = usuario.multiplicadorHFIc || 0;
                                                                        const multiplicadorTempoHFIc = usuario.multiplicadorTempoHFIc || 0;

                                                                        return (
                                                                            <tr 
                                                                                key={`row-profissional-${usuario.idProfissional}`} 
                                                                                style={{
                                                                                    fontSize: '0.74rem',
                                                                                    backgroundColor: 
                                                                                        usuario.horaFaturada < usuario.gatilhoYTD ? '#f1626240' : // Vermelho se menor que gatilho
                                                                                        'transparent' // Sem cor caso contrário
                                                                                }}
                                                                            >
                                                                                <td className="text-center">
                                                                                    {
                                                                                        usuario.isRookie 
                                                                                        ? (<span className="badge bg-warning rokie">R</span>) 
                                                                                        : '-'
                                                                                    }
                                                                                </td>
                                                                                <td className="text-center">{ usuario.nome }</td>
                                                                                <td className="text-center">{ usuario.nomeArea }</td>
                                                                                
                                                                                <td className="text-center">{ usuario.horaFaturada.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 5 }) }</td>
                                                                                <td className="text-center">{ usuario.hfMu == 0 ? '-' : usuario.hfMu.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 5 }) }</td>
                                                                                <td className="text-center">{ usuario.hfMg.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 5 }) }</td>

                                                                                <td className="text-center">{ (usuario.calibracaoTotal * 100).toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) }%</td>
                                                                                <td className="text-center">{ usuario.gatilhoCalibrado.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) }</td>
                                                                                <td className="text-center">{ usuario.metaCalibrada.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) }</td>
                                                                                { new Date(programaData?.dataInicio).getFullYear() !== 2023 && ( <td className="text-center">{ usuario.superMetaCalibrada.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) }</td> )}

                                                                                <td className="text-center">{ usuario.gatilhoYTD.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) }</td>
                                                                                <td className="text-center">{ usuario.metaYTD.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) }</td>
                                                                                { new Date(programaData?.dataInicio).getFullYear() !== 2023 && ( <td className="text-center">{ usuario.superMetaYTD.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) }</td> )}

                                                                                <td className="text-center">
                                                                                    { 
                                                                                        (() => {
                                                                                            const perc = usuario.percGatilhoYTD;
                                                                                            
                                                                                            if (perc >= 100) return <i className="fa fa-arrow-up text-success me-2" aria-hidden="true"></i>;
                                                                                            if (perc >= 75) return <i className="fa fa-arrow-up text-warning me-2" aria-hidden="true"></i>;
                                                                                            if (perc >= 50) return <i className="fa fa-arrow-down text-warning me-2" aria-hidden="true"></i>;
                                                                                            return <i className="fa fa-arrow-down text-danger me-2" aria-hidden="true"></i>;
                                                                                        })()
                                                                                    }
                                                                                    { usuario.percGatilhoYTD.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) }%
                                                                                </td>
                                                                                <td className="text-center">
                                                                                    { 
                                                                                        (() => {
                                                                                            const perc = usuario.percMetaYTD;
                                                                                            
                                                                                            if (perc >= 100) return <i className="fa fa-arrow-up text-success me-2" aria-hidden="true"></i>;
                                                                                            if (perc >= 75) return <i className="fa fa-arrow-up text-warning me-2" aria-hidden="true"></i>;
                                                                                            if (perc >= 50) return <i className="fa fa-arrow-down text-warning me-2" aria-hidden="true"></i>;
                                                                                            return <i className="fa fa-arrow-down text-danger me-2" aria-hidden="true"></i>;
                                                                                        })()
                                                                                    }
                                                                                    { usuario.percMetaYTD.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) }%
                                                                                </td>
                                                                                { new Date(programaData?.dataInicio).getFullYear() !== 2023 && (
                                                                                <td className="text-center">
                                                                                    { 
                                                                                        (() => {
                                                                                            const perc = usuario.percSuperMetaYTD;
                                                                                            
                                                                                            if (perc >= 100) return <i className="fa fa-arrow-up text-success me-2" aria-hidden="true"></i>;
                                                                                            if (perc >= 75) return <i className="fa fa-arrow-up text-warning me-2" aria-hidden="true"></i>;
                                                                                            if (perc >= 50) return <i className="fa fa-arrow-down text-warning me-2" aria-hidden="true"></i>;
                                                                                            return <i className="fa fa-arrow-down text-danger me-2" aria-hidden="true"></i>;
                                                                                        })()
                                                                                    }
                                                                                    { usuario.percSuperMetaYTD.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) }%
                                                                                </td>
                                                                                )}

                                                                                <td className="text-center">{ hfmic.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 5 }) }</td>
                                                                                <td className="text-center">
                                                                                        { 
                                                                                            usuario.isApto && usuario.isAptoMP
                                                                                                ? meritos.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                                                                : "-" 
                                                                                        }
                                                                                    </td>
                                                                                    <td className="text-center">{ 
                                                                                        usuario.isApto && hfmic >= programaData.gatilhos[0].horaFaturadaIndividual
                                                                                            ?  usuario.isAptoMP
                                                                                                ? multiplicador.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) 
                                                                                                : multiplicadorHFIc.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                                                            : 'S/ Mult.'
                                                                                    }
                                                                                    </td>
                                                                                    <td className="text-center">{ 
                                                                                        usuario.isApto && hfmic >= programaData.gatilhos[0].horaFaturadaIndividual
                                                                                            ?  usuario.isAptoMP
                                                                                                ? multiplicadorTempo.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) 
                                                                                                : multiplicadorTempoHFIc.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                                                            : 'S/ Mult.'
                                                                                    }
                                                                                    </td>
                                                                                <td className="text-center">{ ((usuario.horaRecebida / usuario.horaFaturada) * 100 > 0 ? (usuario.horaRecebida / usuario.horaFaturada) * 100 : 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }</td>
                                                                            </tr>
                                                                        )})
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                ) : listaUsuariosData?.data?.usuarios && listaUsuariosData.data?.usuarios?.length === 0 ? (
                                                    <StldColumn xs="12" sm="12" md="12">
                                                        <div className="alert alert-warning" role="alert">
                                                            Atenção! Nenhum resultado encontrado!
                                                        </div>
                                                    </StldColumn>
                                                ) : (
                                                    <StldColumn xs="12" sm="12" md="12">
                                                        {/* <div className="alert alert-warning" role="alert">
                                                            Erro ao carregar os dados ou estrutura inesperada.
                                                        </div> */}
                                                    </StldColumn>
                                                )
                                            }
                                        </StyledTablePage>
                                    </StyledTablePmePrograma>
                                }
                                </StyledForm>
                            </Flex>
                        </StldRow>
                    </div>
                </StyledDefaultPage>
                </main>
        </section >
    );
};

export const ResultadosProgramaPmePage = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    return (
        <>
            {isMenuOpen ? (
                <MenuPage
                    isMenuOpen={isMenuOpen}
                    setIsMenuOpen={setIsMenuOpen}
                />
            ) : (
                <>
                    <Header
                        isMenuOpen={isMenuOpen}
                        setIsMenuOpen={setIsMenuOpen}
                    />
                    <PmeResultadosPrograma />
                </>
            )}
        </>
    );
};